import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toolbar from './Toolbar';
import VideoDiv from './VideoDiv';
import MainText from './MainText';
import ImageDiv from './ImageDiv';
class VideoLayout extends Component {
    render() {
        return (
            <div className="layout-page">
                {/* this scene has a title, some action buttons, stored in an array, with type data, visual elements (how many? what type?) stored in an array, with type data, and data about next available scenes, stored in an array */}
                <div className="flex-box flex-center">

                    <div className="column-lg-10 column-sm-12 column-md-12">
             {this.props.activeScene.title !== null && <h2><span className="title">{this.props.activeScene.title}</span></h2>} 
                    </div>
                </div>
                <div className="flex-box flex-center">
                <div className="column-lg-12 column-md-12 column-sm-12">
                <div className="flex-box flex-evenly">
                {this.props.activeScene.text.length > 0 && <div className="column-lg-4 column-md-12 column-sm-12 flex-box">
                        {this.props.activeScene.text.map((text, i) => {
                            return (<MainText className={`text-div text-light-div`} text={text} key={i}/>);
                        })}
                    {this.props.activeScene.images.length > 0 && <div>{this.props.activeScene.images.map((image, i) => {
                return (<ImageDiv columns={`column-lg-12 column-sm-12 column-md-12`} image={image} key={i}/>);
            })}
                        </div>}
                    </div>}
                    {this.props.activeScene.videos.length > 0 && <div className="column-lg-8 column-md-12 column-sm-12">
                        {this.props.activeScene.videos.map((video, i) => {
                            return (<VideoDiv video={video} key={i}/>)
                        })}
                    </div>}
            
                </div>
                </div>
                </div>
                <Toolbar history={this.props.history}/>
            </div>

        );
    }
}
const mapStateToProps = state => ({
    activeScene: state.activeScene
})
export default connect(mapStateToProps)(VideoLayout);